export type ChecklistAnswer = 'ok' | 'nc' | 'na' | '';

export interface ChecklistItemDef {
  id: string;
  section: string;
  label: string;
  /** Só faz sentido exibir/ocultar no PDF/UI quando marcado como consignado */
  consignmentOnly?: boolean;
}

/** Checklist genérico de entrada / vistoria (reforço de itens para consignação). */
export const VEHICLE_CHECKLIST_ITEMS: ChecklistItemDef[] = [
  { id: 'doc_crlv', section: 'Documentação', label: 'CRLV (documento do veículo) conferido' },
  { id: 'doc_proprietario', section: 'Documentação', label: 'Documento de identificação do proprietário / consignante' },
  { id: 'doc_nf', section: 'Documentação', label: 'Nota fiscal ou comprovante de origem (quando aplicável)' },
  { id: 'doc_ipva', section: 'Documentação', label: 'IPVA — situação conferida' },
  { id: 'doc_lic', section: 'Documentação', label: 'Licenciamento em dia' },
  { id: 'doc_chaves', section: 'Documentação', label: 'Chaves (quantidade e funcionamento das existentes)' },
  { id: 'doc_manual', section: 'Documentação', label: 'Manual e documentos de revisão (se houver)' },
  { id: 'id_chassi', section: 'Identificação do veículo', label: 'Chassi conferido com documentação' },
  { id: 'id_placa', section: 'Identificação do veículo', label: 'Placa / identificação conferida com cadastro' },
  { id: 'id_km', section: 'Identificação do veículo', label: 'Quilometragem / horas registradas no ato da vistoria' },
  { id: 'lat_geral', section: 'Lataria e pintura', label: 'Estado geral da pintura e alinhamento aparente' },
  { id: 'lat_avarias', section: 'Lataria e pintura', label: 'Avarias, amassados ou reparos aparentes anotados' },
  { id: 'lat_parachoque_d', section: 'Lataria e pintura', label: 'Pára-choque dianteiro' },
  { id: 'lat_parachoque_t', section: 'Lataria e pintura', label: 'Pára-choque traseiro' },
  { id: 'pneus', section: 'Pneus e rodas', label: 'Estado dos pneus, rodas e calibragem aparente' },
  { id: 'estepe', section: 'Pneus e rodas', label: 'Estepe, macaco e chave de roda' },
  { id: 'vidro_frente', section: 'Vidros', label: 'Para-brisa (trincas, riscos relevantes)' },
  { id: 'vidro_outros', section: 'Vidros', label: 'Vidros laterais e traseiro' },
  { id: 'int_estofado', section: 'Interior', label: 'Estofados, carpete e teto' },
  { id: 'int_multimidia', section: 'Interior', label: 'Multimídia / som / câmera de ré (se houver)' },
  { id: 'int_ar', section: 'Interior', label: 'Ar-condicionado — funcionamento básico' },
  { id: 'mec_luzes', section: 'Mecânica e elétrica (verificação inicial)', label: 'Luzes de advertência no painel ao ligar' },
  { id: 'mec_fluidos', section: 'Mecânica e elétrica (verificação inicial)', label: 'Vazamentos aparentes / fluidos (observação visual)' },
  { id: 'cs_contrato', section: 'Consignação', label: 'Contrato ou termo de consignação assinado / conferido', consignmentOnly: true },
  { id: 'cs_dados', section: 'Consignação', label: 'Dados do consignante conferidos (nome, contato, valores)', consignmentOnly: true },
  { id: 'cs_disponibilidade', section: 'Consignação', label: 'Combinado com proprietário: exposição, preço e prazos', consignmentOnly: true },
];

export function initialChecklistAnswers(): Record<string, ChecklistAnswer> {
  const o: Record<string, ChecklistAnswer> = {};
  for (const it of VEHICLE_CHECKLIST_ITEMS) o[it.id] = '';
  return o;
}
